import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "37",
  height: "36",
  viewBox: "0 0 37 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16.4 24.9L26.975 14.325L24.875 12.225L16.4 20.7L12.125 16.425L10.025 18.525L16.4 24.9ZM18.5 33C16.425 33 14.475 32.606 12.65 31.818C10.825 31.03 9.2375 29.9615 7.8875 28.6125C6.5375 27.2625 5.469 25.675 4.682 23.85C3.895 22.025 3.501 20.075 3.5 18C3.5 15.925 3.894 13.975 4.682 12.15C5.47 10.325 6.5385 8.7375 7.8875 7.3875C9.2375 6.0375 10.825 4.969 12.65 4.182C14.475 3.395 16.425 3.001 18.5 3C20.575 3 22.525 3.394 24.35 4.182C26.175 4.97 27.7625 6.0385 29.1125 7.3875C30.4625 8.7375 31.5315 10.325 32.3195 12.15C33.1075 13.975 33.501 15.925 33.5 18C33.5 20.075 33.106 22.025 32.318 23.85C31.53 25.675 30.4615 27.2625 29.1125 28.6125C27.7625 29.9625 26.175 31.0315 24.35 31.8195C22.525 32.6075 20.575 33.001 18.5 33ZM18.5 30C21.85 30 24.6875 28.8375 27.0125 26.5125C29.3375 24.1875 30.5 21.35 30.5 18C30.5 14.65 29.3375 11.8125 27.0125 9.4875C24.6875 7.1625 21.85 6 18.5 6C15.15 6 12.3125 7.1625 9.9875 9.4875C7.6625 11.8125 6.5 14.65 6.5 18C6.5 21.35 7.6625 24.1875 9.9875 26.5125C12.3125 28.8375 15.15 30 18.5 30Z",
      fill: "#5B0360"
    }, null, -1)
  ])))
}
export default { render: render }